import { useCallback } from 'react';
import { NavigateOptions as NavigateOptionsOriginal, To, useNavigate as useNavigateOriginal } from 'react-router-dom';

type UseNavigateOptions = {
	scroll?: string[];
};

type NavigateOptions = NavigateOptionsOriginal & {
	scroll?: string[];
};

const scrollElement = (element: HTMLElement) => {
	setTimeout(() => {
		element.scrollTo({ top: 0 });
	}, 1);
};
const scrollElementsByIds = (elementsIds: string[]) => {
	elementsIds.forEach((elementId) => {
		const element = document.getElementById(elementId);
		if (element) {
			scrollElement(element);
		}
	});
};
export const useNavigate = (options?: UseNavigateOptions) => {
	const navigateOriginal = useNavigateOriginal();
	const scroll = options?.scroll;
	return useCallback(
		(to: To, navigateOptions?: NavigateOptions): void | Promise<void> => {
			if (scroll && scroll.length > 0) {
				scrollElementsByIds(scroll);
			}
			if (navigateOptions?.scroll && navigateOptions.scroll.length > 0) {
				scrollElementsByIds(navigateOptions.scroll);
			}
			return navigateOriginal(to, {
				replace: navigateOptions?.replace,
				state: navigateOptions?.state,
			});
		},
		[navigateOriginal, scroll]
	);
};
